export default __webpack_public_path__ + "static/media/ss-standard.91e8a5b7.woff";